<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400 fade-in-section">
        <div
          class="hero-carousel"
          @mouseenter="stopHeroCarousel"
          @mouseleave="startHeroCarousel"
        >
          <div class="hero-carousel__viewport">
            <div
              v-for="(slide, index) in heroSlides"
              :key="slide.alt"
              class="hero-carousel__slide"
              :class="{ 'is-active': index === currentHeroSlide }"
            >
            <router-link to="/download" class="download-btn-fixed">
              <span class="download-btn-text">Tải ứng dụng</span>
              <svg class="download-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
            </router-link>
              <img :src="slide.image" :alt="slide.alt" class="hero-carousel__image" />
            </div>
          </div>

          <button
            type="button"
            class="hero-carousel__arrow hero-carousel__arrow--prev"
            aria-label="Previous slide"
            @click="handlePrevHeroSlide"
          >
            &lt;
          </button>

          <button
            type="button"
            class="hero-carousel__arrow hero-carousel__arrow--next"
            aria-label="Next slide"
            @click="handleNextHeroSlide"
          >
            &gt;
          </button>

          <div class="hero-carousel__dots">
            <button
              v-for="(slide, index) in heroSlides"
              :key="`${slide.alt}-dot`"
              type="button"
              class="hero-carousel__dot"
              :class="{ 'is-active': index === currentHeroSlide }"
              :aria-label="`Go to slide ${index + 1}`"
              @click="setHeroSlide(index)"
            ></button>
          </div>
        </div>
      </div>
    </div>

<!-- ------------------------------ -->
 
  <div style="margin-top: 100px;" class="container-fluid p-0 overflow-hidden expand-gallery-shell max-w-1400" id="gallery_xuvxev27s">
    <div class="text-center mb-5 position-relative z-1">
            <h2 class="appImgTitle">Hãy gia nhập cộng đồng hơn 300.000 người dùng, mua sắm, vay vốn và tiết kiệm thông minh hơn cùng Lavi Finance.</h2>
          </div>
        
        <div class="service-showcase">
          <button
            type="button"
            class="service-showcase__arrow service-showcase__arrow--prev"
            aria-label="Previous service slide"
            @click="prevServiceSlide"
          >
            <span aria-hidden="true">‹</span>
          </button>

          <div class="service-showcase__card" @click="goToDetail(currentServiceSlide)">
            <div class="service-showcase__media">
              <transition name="service-slide-fade" mode="out-in">
                <img
                  :key="serviceSlides[currentServiceSlide].image"
                  :src="serviceSlides[currentServiceSlide].image"
                  :alt="serviceSlides[currentServiceSlide].alt"
                  class="service-showcase__image"
                />
              </transition>
            </div>

            <div class="service-showcase__content" >
              <transition name="service-copy-fade" mode="out-in">
                <div
                  :key="serviceSlides[currentServiceSlide].alt + '-copy'"
                  class="service-showcase__copy"
                >
                  <h3 class="service-showcase__title">
                    {{ serviceSlides[currentServiceSlide].title }}
                  </h3>
                  <button type="button" class="service-showcase__link">
                    {{ serviceSlides[currentServiceSlide].cta }}
                  </button>
                </div>
              </transition>

              <div class="service-showcase__dots">
                <button
                  v-for="(slide, index) in serviceSlides"
                  :key="slide.alt"
                  type="button"
                  class="service-showcase__dot"
                  :class="{ 'is-active': index === currentServiceSlide }"
                  :aria-label="`Go to service slide ${index + 1}`"
                  @click="setServiceSlide(index)"
                ></button>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="service-showcase__arrow service-showcase__arrow--next"
            aria-label="Next service slide"
            @click="nextServiceSlide"
          >
            <span aria-hidden="true">›</span>
          </button>
        </div>
  </div>

      
<!-- ------------------------------ -->


<!-- ------------------------------ -->

    <div class="appImg min-w-1400" style="text-align: center;">
        <div class="container py-5 overflow-hidden" style="margin: 0 auto;">
          <!-- Header -->
          <div class="text-center mb-5 position-relative z-1">
          </div>

          <div class="app-showcase">
            <div class="app-showcase__info">
              <div class="app-promo">
                <h3 class="app-promo__eyebrow">Lavi Finance </h3>
                <h4 class="app-promo__title">APP</h4>
                <p class="app-promo__text">
                  Tài chính thông minh, Tiếp sức cuộc sống
                </p>

                <div class="app-promo__downloads">
                  <div class="app-promo__stores">
                    <a
                      href="https://apps.apple.com/vn/app/lavi-finance/id6741784212"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="app-store-btn app-store-btn--large"
                    >
                      <svg class="app-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                      </svg>
                      <div class="app-text">
                        <span class="app-small">Download on the</span>
                        <span class="app-large">App Store</span>
                      </div>
                    </a>

                   
                  </div>

                  <div class="app-qr">
                    <div class="app-qr__frame">
                      <img :src="q1" alt="">
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="app-showcase__visual">
              <div class="gallery-stage position-relative mx-auto" id="gallery_aki4g">
                <div class="glow-blob" style="background: #3b82f6;"></div>

                <div class="gallery-item" data-index="0">
                  <div class="phone-frame">
                    <div class="notch"></div>
                    <div class="side-btn volume-up"></div>
                    <div class="side-btn volume-down"></div>
                    <div class="side-btn power"></div>
                  </div>

                  <div class="image-container">
                    <img :src="appImg1" alt="App Screen 1" />
                  </div>

                  <div class="screen-reflection"></div>
                </div>

                <div class="gallery-item" data-index="1">
                  <div class="phone-frame">
                    <div class="notch"></div>
                    <div class="side-btn volume-up"></div>
                    <div class="side-btn volume-down"></div>
                    <div class="side-btn power"></div>
                  </div>

                  <div class="image-container">
                    <img :src="appImg2" alt="App Screen 2" />
                  </div>

                  <div class="screen-reflection"></div>
                </div>

                <div class="gallery-item" data-index="2">
                  <div class="phone-frame">
                    <div class="notch"></div>
                    <div class="side-btn volume-up"></div>
                    <div class="side-btn volume-down"></div>
                    <div class="side-btn power"></div>
                  </div>

                  <div class="image-container">
                    <img :src="appImg3" alt="App Screen 3" />
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-center gap-2 mt-4" id="gallery_aki4g_indicators">
                <button
                  v-for="index in 3"
                  :key="'gallery-dot-' + index"
                  type="button"
                  class="indicator-dot"
                  @click="setAppGalleryIndex(index - 1)"
                ></button>
              </div>
            </div>
          </div>

        </div>
    </div>

<!-- ------------------------------ -->

<!-- ------------------------------ -->

<div class="features-section min-w-1400">
  <div class="features-container max-w-1400">
    <div class="features-header">
      <h2 class="features-title">Ưu điểm vượt trội</h2>
      
    </div>
    
    <div class="features-grid">
      <div class="feature-card">
          <h2>Khoản vay linh hoạt</h2>
        <h3 class="feature-card-title">Hạn mức lên đến 30.000.000 VNĐ</h3>
        <p class="feature-card-desc">Đáp ứng đa dạng nhu cầu: tiêu dùng, mua sắm, học tập hoặc kinh doanh nhỏ. </p>
      </div>
      <div class="feature-card">
        
          <h2>Lãi suất minh bạch</h2>
        
        <h3 class="feature-card-title">Lãi suất hấp dẫn, không phí ẩn</h3>
        <p class="feature-card-desc">Chỉ từ 21.9%/năm, thông tin rõ ràng và phù hợp với khả năng tài chính của bạn.</p>
      </div>
      <div class="feature-card">
        
          <h2>Phê duyệt thần tốc</h2>
        
        <h3 class="feature-card-title"> Duyệt hồ sơ nhanh chóng chỉ với CCCD</h3>
        <p class="feature-card-desc"> Quy trình 100% trực tuyến, đơn giản hóa mọi thủ tục, không cần chứng minh thu nhập.</p>
      </div>
      <div class="feature-card">
          <h2>An toàn & Uy tín</h2>
        <h3 class="feature-card-title"> Hệ thống bảo mật chuẩn Ngân hàng</h3>
        <p class="feature-card-desc">Vận hành bởi VIB AMC, cam kết bảo vệ tuyệt đối thông tin và quyền riêng tư của khách hàng. </p>
      </div>
    </div>
  </div>
</div>

<!-- ------------------------------ -->

<!-- ------------------------------ -->
 <div class="loan-estimator-section min-w-1400">
  <div class="loan-estimator-card max-w-1400 fade-in-section">
    <div class="loan-estimator-header">
      <h2 class="loan-estimator-title">Tính toán khoản vay dự kiến</h2>
    </div>

    <div class="loan-estimator-body">
      <div class="loan-estimator-controls">
        <div class="loan-control">
          <div class="loan-control__top">
            <label class="loan-control__label" for="loan-amount-range">
              Số tiền vay mong muốn
            </label>
            <div class="loan-control__value-box">
              <span class="loan-control__value">
                {{ formatCurrency(loanAmount) }}
              </span>
              <span class="loan-control__unit">VND</span>
            </div>
          </div>

          <input
            id="loan-amount-range"
            v-model.number="loanAmount"
            class="loan-range"
            type="range"
            :min="loanAmountMin"
            :max="loanAmountMax"
            :step="loanAmountStep"
            :style="{ '--range-progress': `${amountProgress}%` }"
          />

          <div class="loan-control__limits">
            <span>{{ formatCurrency(loanAmountMin) }}</span>
            <span>{{ formatCurrency(loanAmountMax) }}</span>
          </div>
        </div>

        <div class="loan-control">
          <div class="loan-control__top">
            <label class="loan-control__label" for="loan-term-range">
              Thời hạn vay
            </label>
            <div class="loan-control__value-box">
              <span class="loan-control__value">{{ loanTerm }}</span>
              <span class="loan-control__unit">ngày</span>
            </div>
          </div>

          <input
            id="loan-term-range"
            v-model.number="loanTerm"
            class="loan-range"
            type="range"
            :min="loanTermMin"
            :max="loanTermMax"
            :step="loanTermStep"
            :style="{ '--range-progress': `${termProgress}%` }"
          />

          <div class="loan-control__limits">
            <span>{{ loanTermMin }} ngày</span>
            <span>{{ loanTermMax }} ngày</span>
          </div>
        </div>
      </div>

      <div class="loan-estimator-summary">
        <div class="loan-summary-box">
          <p class="loan-summary-box__label">Thanh toán hàng tháng ước tính</p>
          <div class="loan-summary-box__amount">
            <span class="loan-summary-box__amount-number">
              {{ formatCurrency(monthlyPayment) }}
            </span>
            <span class="loan-summary-box__amount-unit">VND</span>
          </div>
          <p class="loan-summary-box__daily">
            (Chỉ từ
            <span>{{ formatCurrency(dailyPayment) }} VND</span>
            /VNĐ/ngày)
          </p>
        </div>

        <a
          class="loan-summary-action"
          :href="loanCheckLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          ĐĂNG KÝ NGAY
        </a>

        <p class="loan-summary-note">
          Kết quả tính toán chỉ mang tính chất tham khảo dựa trên lãi suất cố định 21.9%/năm. Ví dụ: Nếu khách hàng vay 25.000.000 VNĐ trong 180 ngày, tổng lãi là 2.700.000 VNĐ, tổng số tiền thanh toán là 27.700.000 VNĐ (khoảng 4.616.666 VNĐ/tháng). Lavi Finance không thu phí ẩn, lãi suất thực tế sẽ phụ thuộc vào hồ sơ tín dụng của từng cá nhân.
        </p>
      </div>
    </div>
  </div>
 </div>
<!-- ------------------------------ -->


<!-- ------------------------------ -->
<div class="loan-steps-section min-w-1400">
  <div class="loan-steps-wrap max-w-1400 fade-in-section">
    <div class="loan-steps-header">
      <h2 class="loan-steps-title">Quy trình 4 bước</h2>
      <!-- <p class="loan-steps-subtitle">4个简单的借用步骤</p> -->
    </div>

    <div class="loan-steps-grid">
      <article
        v-for="step in loanStepCards"
        :key="step.number"
        class="loan-step-card"
      >
        <div class="loan-step-badge">{{ step.number }}</div>

        <div class="loan-step-copy">
          <h3 class="loan-step-title">{{ step.title }}</h3>
          <p class="loan-step-title-secondary">{{ step.titleSecondary }}</p>

          <p
            v-for="line in step.description"
            :key="`${step.number}-${line}`"
            class="loan-step-text"
          >
            {{ line }}
          </p>
        </div>

        <!-- <div class="loan-step-visual">
          <div class="loan-step-visual-frame" :class="step.visualClass">
            <span class="loan-step-glow loan-step-glow--one"></span>
            <span class="loan-step-glow loan-step-glow--two"></span>
            <span class="loan-step-floor"></span>

            <template v-if="step.visualClass === 'loan-step-visual-frame--check'">
              <span class="loan-step-chip"></span>
              <span class="loan-step-magnifier"></span>
              <span class="loan-step-hand"></span>
            </template>

            <template v-else-if="step.visualClass === 'loan-step-visual-frame--form'">
              <span class="loan-step-cardboard"></span>
              <span class="loan-step-avatar"></span>
              <span class="loan-step-line loan-step-line--one"></span>
              <span class="loan-step-line loan-step-line--two"></span>
              <span class="loan-step-success"></span>
            </template>

            <template v-else>
              <span class="loan-step-phone"></span>
              <span class="loan-step-cash loan-step-cash--one"></span>
              <span class="loan-step-cash loan-step-cash--two"></span>
              <span class="loan-step-coin"></span>
            </template>
          </div>
        </div> -->
      </article>
    </div>
  </div>
</div>
<!-- ------------------------------ -->



    
  </div>
</template>



<script>
import "./index.css";
import importedImg1 from "@/page/lavifinancecompany/components/img/1_1.png";
import importedImg2 from "@/page/lavifinancecompany/components/img/1_2.png";
import importedImg3 from "@/page/lavifinancecompany/components/img/1_3.png";
import importedImg4 from "@/page/lavifinancecompany/components/img/1_4.png";
import bannerImg1 from "@/page/lavifinancecompany/components/img/banner-1.png";
import bannerImg2 from "@/page/lavifinancecompany/components/img/banner-2.png";
import bannerImg3 from "@/page/lavifinancecompany/components/img/banner-3.png";
import appImg1 from "@/page/lavifinancecompany/components/img/app-1.jpg";
import appImg2 from "@/page/lavifinancecompany/components/img/app-2.jpg";
import appImg3 from "@/page/lavifinancecompany/components/img/app-3.jpg";

import imgImg1 from "@/page/lavifinancecompany/components/img/img-1.png";
import imgImg2 from "@/page/lavifinancecompany/components/img/img-2.png";
import imgImg3 from "@/page/lavifinancecompany/components/img/img-3.png";

import downloadImg from "@/page/lavifinancecompany/components/img/download.png";
import logoImg from "@/page/lavifinancecompany/components/img/logo.png";
import q1 from "@/page/lavifinancecompany/components/img/q-1.png";
// import importedImg5 from "@/page/lavifinancecompany/components/img/1_5.png";
// import importedImg6 from "@/page/lavifinancecompany/components/img/1_6.png";

const loanCheckLink =
  "https://apps.apple.com/vn/app/lavi-finance/id6741784212";
const monthlyInterestRate = 0.012;
// const monthlyServiceFeeRate = 0.00876336672;
const serviceSlides = [
  {
    image: imgImg1,
    alt: "Lavi Finance service slide 1",
    title: "Sử dụng Lavi Finance, tận hưởng ưu đãi lên đến 600.000 VNĐ, trả góp nhẹ nhàng hơn!",
    cta: "Giảm bớt áp lực thanh toán cuối tháng, giúp tài chính tự do hơn nhờ tính năng trả góp!",
    herf:'https://www.lavifinance.com/vi/khuyen-mai/quet-sach-hoa-don-thanh-toan-khoan-vay-voi-uu-dai-cuc-hoi-len-den-500000-dong'
  },
  {
    image: imgImg2,
    alt: "Lavi Finance service slide 2",
    title: "Giải ngân ngay - 100% Trúng thẻ nạp điện thoại lên đến 500.000 VNĐ!",
    cta: 'Từ ngày 15/05 đến 20/06/2026, Lavi Finance chính thức khởi động tuần lễ "Cùng Lavi đón vận may"! ',
    herf:'https://www.lavifinance.com/vi/khuyen-mai/giai-ngan-tuc-thi-trung-the-cao-het-y-len-toi-500000-dong'
  },
  {
    image: imgImg3,
    alt: "Lavi Finance service slide 3",
    title: "Lavi Finance khởi động chương trình “Đồng Tâm Hiệp Lực”, giảm lãi suất lên đến 50%, đồng hành tái thiết cuộc sống tốt đẹp hơn!",
    cta: "Lavi Finance triển khai “Chương trình ưu đãi giảm lãi suất đặc biệt” dành cho khách hàng ưu chất lượng cao tại các khu vực cụ thể và đáp ứng điều kiện",
    herf:'https://www.lavifinance.com/vi/khuyen-mai/mcredit-se-chia-cung-dong-bao-tai-thiet-cuoc-song-voi-chuong-trinh-giam-lai-suat'
  },
];

export default {
  data() {
    return {
      currentHeroSlide: 0,
      currentServiceSlide: 0,
      heroCarouselTimer: null,
      serviceCarouselTimer: null,
      serviceSlides,
      heroSlides: [
        {
          image: bannerImg1,
          alt: "Lavi Finance banner 2",
        },
        {
          image: bannerImg2,
          alt: "Lavi Finance banner 3",
        },
        {
          image: bannerImg3,
          alt: "Lavi Finance banner 4",
        },
      ],
      loanAmount: 400000,
      loanAmountMin: 400000,
      loanAmountMax:  30000000,
      loanAmountStep: 400000,
      loanTerm: 91,
      loanTermMin: 91,
      loanTermMax: 365,
      loanTermStep: 1,
      loanCheckLink: loanCheckLink,
      loanStepCards: [
        {
          number: "1",
          title: "Tải ứng dụng & Đăng ký",
          titleSecondary: "",
          description: [
            "Tải ứng dụng Lavi Finance từ App Store và đăng ký bằng số điện thoại của bạn.",
            "",
          ],
          visualClass: "loan-step-visual-frame--check",
        },
        {
          number: "2",
          title: "Cung cấp thông tin cơ bản",
          titleSecondary: "",
          description: [
            "Chỉ cần ảnh chụp CCCD và hoàn thành các thông tin cơ bản trong 3 phút. Không cần chứng minh thu nhập.",
            "",
          ],
          visualClass: "loan-step-visual-frame--form",
        },
        {
          number: "3",
          title: "Chờ phê duyệt tự động",
          titleSecondary: "",
          description: [
            " Hệ thống thông minh sẽ kiểm tra và phê duyệt hạn mức vay của bạn một cách nhanh chóng và bảo mật.",
            "",
          ],
          visualClass: "loan-step-visual-frame--check",
        },
        {
          number: "4",
          title: "Nhận tiền vào tài khoản",
          titleSecondary: "",
          description: [
            "Ký hợp đồng điện tử và nhận tiền giải ngân ngay vào tài khoản ngân hàng của bạn trong 10 phút. ",
            "",
          ],
          visualClass: "loan-step-visual-frame--money",
        },
      ],
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      appImg1: appImg1,
      appImg2: appImg2,
      appImg3: appImg3,
      logoImg: logoImg,
      q1: q1,
      // importedImg5: importedImg5,
      // importedImg6: importedImg6,
      altText: "图片",
      downloadImg: downloadImg,
    };
  },
  computed: {
    amountProgress() {
      return this.getRangeProgress(
        this.loanAmount,
        this.loanAmountMin,
        this.loanAmountMax
      );
    },
    termProgress() {
      return this.getRangeProgress(
        this.loanTerm,
        this.loanTermMin,
        this.loanTermMax
      );
    },
    monthlyPayment() {
      return this.calculateMonthlyPayment(this.loanAmount, this.loanTerm);
    },
    dailyPayment() {
      return Math.round(this.monthlyPayment / this.loanTerm);
    },
  },
  mounted() {
    this.InitPage();
    this.appImgFn();
    this.startHeroCarousel();
    this.startServiceCarousel();
  },
  beforeDestroy() {
    this.stopHeroCarousel();
    this.stopServiceCarousel();
  },
  methods: {

    goToDetail(index){
      window.open(`${serviceSlides[index].herf}`,'_blank' );
      
    },


    setAppGalleryIndex(index) {
      if (window.setGalleryIndex) {
        window.setGalleryIndex("gallery_aki4g", index);
      }
    },

    setServiceSlide(index) {
      if (index === this.currentServiceSlide) {
        return;
      }
      this.currentServiceSlide = index;
      this.restartServiceCarousel();
    },

    nextServiceSlide() {
      this.currentServiceSlide =
        (this.currentServiceSlide + 1) % this.serviceSlides.length;
      this.restartServiceCarousel();
    },

    prevServiceSlide() {
      this.currentServiceSlide =
        (this.currentServiceSlide - 1 + this.serviceSlides.length) %
        this.serviceSlides.length;
      this.restartServiceCarousel();
    },

    rotateServiceSlide() {
      this.currentServiceSlide =
        (this.currentServiceSlide + 1) % this.serviceSlides.length;
    },

    startServiceCarousel() {
      this.stopServiceCarousel();
      this.serviceCarouselTimer = setInterval(() => {
        this.rotateServiceSlide();
      }, 4500);
    },

    stopServiceCarousel() {
      if (this.serviceCarouselTimer) {
        clearInterval(this.serviceCarouselTimer);
        this.serviceCarouselTimer = null;
      }
    },

    restartServiceCarousel() {
      this.startServiceCarousel();
    },

    formatCurrency(value) {
      return Number(value || 0).toLocaleString("vi-VN");
    },

    setHeroSlide(index) {
      this.currentHeroSlide = index;
      this.restartHeroCarousel();
    },

    nextHeroSlide() {
      this.currentHeroSlide = (this.currentHeroSlide + 1) % this.heroSlides.length;
    },

    prevHeroSlide() {
      this.currentHeroSlide =
        (this.currentHeroSlide - 1 + this.heroSlides.length) %
        this.heroSlides.length;
    },

    handleNextHeroSlide() {
      this.nextHeroSlide();
      this.restartHeroCarousel();
    },

    handlePrevHeroSlide() {
      this.prevHeroSlide();
      this.restartHeroCarousel();
    },

    startHeroCarousel() {
      this.stopHeroCarousel();
      this.heroCarouselTimer = setInterval(() => {
        this.nextHeroSlide();
      }, 4000);
    },

    stopHeroCarousel() {
      if (this.heroCarouselTimer) {
        clearInterval(this.heroCarouselTimer);
        this.heroCarouselTimer = null;
      }
    },

    restartHeroCarousel() {
      this.startHeroCarousel();
    },

    getRangeProgress(value, min, max) {
      if (max === min) {
        return 0;
      }
      return ((value - min) / (max - min)) * 100;
    },

    calculateMonthlyPayment(amount, term) {
      if (!amount || !term) {
        return 0;
      }

      const month = term / 30

      const totalAmount = amount + ((amount * monthlyInterestRate) * month);
      
      const m = (totalAmount / month);
      
      return Math.round(m);
    },

    appImgFn() {
            const uid = 'gallery_aki4g';
            const container = document.getElementById(uid);
            const indicatorsContainer = document.getElementById(uid + '_indicators');
            if (!container || !indicatorsContainer) {
                return;
            }
            const items = container.querySelectorAll('.gallery-item');
            const dots = indicatorsContainer.querySelectorAll('.indicator-dot');
            const total = items.length;
            let currentIndex = 0;
            let timer = null;

            // Global accessor
            window.setGalleryIndex = function(targetUid, index) {
                if(targetUid !== uid) return;
                updateGallery(index);
                resetTimer();
            };

            function updateGallery(activeIdx) {
                currentIndex = activeIdx;

                // Loop through all items and assign classes based on distance from active
                items.forEach((item, i) => {
                    item.className = 'gallery-item'; // Reset
                    
                    if (i === activeIdx) {
                        item.classList.add('active');
                    } else {
                        // Calculate circular distance
                        // If total is 5, active is 0. 
                        // i=4 is "prev" (distance -1 or 4), i=1 is "next" (distance 1)
                        
                        let diff = (i - activeIdx);
                        if (diff < 0) diff += total; // Normalize negative

                        // Check for Prev (Active - 1)
                        const prevIdx = (activeIdx - 1 + total) % total;
                        if (i === prevIdx) {
                            item.classList.add('prev');
                            // Add click listener to bring to center
                            item.onclick = () => window.setGalleryIndex(uid, i);
                        }

                        // Check for Next (Active + 1)
                        const nextIdx = (activeIdx + 1) % total;
                        if (i === nextIdx) {
                            item.classList.add('next');
                             // Add click listener to bring to center
                            item.onclick = () => window.setGalleryIndex(uid, i);
                        }
                        
                        // If only 2 items, Next overrides Prev visually or vice versa logic needs care
                        // But CSS handles opacity.
                    }
                });

                // Update Dots
                dots.forEach((dot, i) => {
                    if(i === activeIdx) dot.classList.add('active');
                    else dot.classList.remove('active');
                });
            }

            function nextSlide() {
                let next = (currentIndex + 1) % total;
                updateGallery(next);
            }

            function resetTimer() {
                if(timer) clearInterval(timer);
                timer = setInterval(nextSlide, 3000);
            }

            // Init
            updateGallery(0);
            resetTimer();

        },


    InitPage(){
      window.scrollTo({ top: 0 });
      const fadeInSections = document.querySelectorAll('.fade-in-section');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
      });
    }, {
        threshold: 0.3
    });
      fadeInSections.forEach(section => {
          observer.observe(section);
      });
    }
  },
};
</script>
<!-- <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css"> -->


<style scoped>
@import url('https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css');
@import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css');

.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
  
    min-height: 400px;
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}

.hero-carousel {
  position: relative;
  width: 100%;
}

.hero-carousel__viewport {
  position: relative;
  width: 100%;
  height: clamp(420px, 38vw, 620px);
  overflow: hidden;
  border-radius: 28px;
  background: linear-gradient(180deg, #f7faff 0%, #edf4ff 100%);
  box-shadow: 0 24px 60px rgba(18, 38, 63, 0.1);
}

.hero-carousel__slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.65s ease;
}

.hero-carousel__slide.is-active {
  opacity: 1;
  z-index: 1;
}

.hero-carousel__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-carousel__arrow {
  position: absolute;
  top: 50%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  color: #ffffff;
  font-size: 34px;
  line-height: 1;
  background: linear-gradient(135deg, rgba(36, 78, 232, 0.92) 0%, rgba(107, 140, 255, 0.92) 100%);
  border: none;
  border-radius: 50%;
  box-shadow: 0 14px 28px rgba(36, 78, 232, 0.22);
  cursor: pointer;
  transform: translateY(-50%);
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.hero-carousel__arrow:hover {
  transform: translateY(-50%) scale(1.04);
  box-shadow: 0 18px 34px rgba(36, 78, 232, 0.28);
}

.hero-carousel__arrow--prev {
  left: 24px;
}

.hero-carousel__arrow--next {
  right: 24px;
}

.hero-carousel__dots {
  position: absolute;
  bottom: 24px;
  left: 50%;
  z-index: 2;
  display: flex;
  gap: 10px;
  padding: 10px 16px;
  background: rgba(15, 29, 58, 0.2);
  border-radius: 999px;
  backdrop-filter: blur(10px);
  transform: translateX(-50%);
}

.hero-carousel__dot {
  width: 10px;
  height: 10px;
  padding: 0;
  background: rgba(255, 255, 255, 0.55);
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: width 0.2s ease, background-color 0.2s ease;
}

.hero-carousel__dot.is-active {
  width: 28px;
  background: #ffffff;
}

.img2Box {
  padding: 0 220px;
}


.img2Box {
  margin: 50px 0;
}

.img4Box {
  margin: 50px 0 90px;
}


 /* Stage Setup */
        .gallery-stage {
            height: 600px;
            width: 100%;
            max-width: 1000px; /* Limits spread of side images */
            perspective: 1000px;
        }

        /* Item Base */
        .gallery-item {
            position: absolute;
            top: 0;
            left: 50%;
            width: 280px; /* Phone Width */
            height: 580px; /* Phone Height */
            transform-origin: center center;
            transition: all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
            /* Initial State: Hidden/Center */
            opacity: 0;
            transform: translateX(-50%) scale(0.8);
            z-index: 0;
            border-radius: 40px;
            overflow: visible; /* Allow buttons to stick out */
        }

        /* Image Handling */
        .image-container {
            width: 100%;
            height: 100%;
            border-radius: 35px; /* Matches internal screen radius */
            overflow: hidden;
            background: #000;
            box-shadow: 0 4px 10px rgba(0,0,0,0.1);
            position: relative;
            z-index: 2;
        }
        .image-container img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        /* --- STATE STYLES --- */

        /* 1. Center (Active) */
        .gallery-item.active {
            opacity: 1;
            transform: translateX(-50%) scale(1);
            z-index: 10;
        }
        
        /* 2. Left (Prev) */
        .gallery-item.prev {
            opacity: 0.6;
            transform: translateX(-140%) scale(0.85) rotateY(15deg); /* Move Left */
            z-index: 5;
            cursor: pointer;
        }

        /* 3. Right (Next) */
        .gallery-item.next {
            opacity: 0.6;
            transform: translateX(40%) scale(0.85) rotateY(-15deg); /* Move Right */
            z-index: 5;
            cursor: pointer;
        }

        /* --- PHONE FRAME STYLING (CSS Only) --- */
        .phone-frame {
            position: absolute;
            top: -12px; left: -12px; right: -12px; bottom: -12px;
            border: 12px solid #1e293b; /* Bezel Color */
            border-radius: 50px;
            pointer-events: none;
            z-index: 20;
            opacity: 0; /* Hidden by default on side images */
            transition: opacity 0.4s ease 0.1s; /* Slight delay to let movement start */
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4);
        }

        /* Only show frame when active */
        .gallery-item.active .phone-frame {
            opacity: 1;
        }
        
        /* Notch */
        .notch {
            position: absolute;
            top: 0; left: 50%;
            transform: translateX(-50%);
            width: 100px; height: 25px;
            background: #1e293b;
            border-bottom-left-radius: 16px;
            border-bottom-right-radius: 16px;
            z-index: 21;
        }

        /* Physical Buttons */
        .side-btn { position: absolute; background: #1e293b; border-radius: 4px; }
        .volume-up { left: -16px; top: 100px; width: 4px; height: 40px; }
        .volume-down { left: -16px; top: 150px; width: 4px; height: 40px; }
        .power { right: -16px; top: 120px; width: 4px; height: 60px; }

        /* Reflection */
        .screen-reflection {
            position: absolute;
            top: 0; left: 0; width: 100%; height: 100%;
            background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, transparent 40%, transparent 100%);
            border-radius: 35px;
            z-index: 15;
            pointer-events: none;
        }

        /* Decor */
        .glow-blob {
            position: absolute;
            top: 50%; left: 50%;
            transform: translate(-50%, -50%);
            width: 350px; height: 350px;
            border-radius: 50%;
            filter: blur(80px);
            opacity: 0.15;
            z-index: 0;
        }

        /* Indicators */
        .indicator-dot {
            width: 8px; height: 8px;
            border-radius: 50%;
            background: #cbd5e1;
            border: none;
            transition: all 0.3s;
            padding: 0;
        }
        .indicator-dot.active {
            background: #3b82f6;
            width: 24px;
            border-radius: 4px;
        }
        .indicator-dot:hover {
            background: #94a3b8;
        }


        .appImgTitle {
            font-size: 34px;
            font-weight: bold;
            color: #333333;
            margin-bottom: 50px;
        }

        .app-showcase {
            display: grid;
            grid-template-columns: 430px minmax(0, 1fr);
            align-items: center;
            gap: 42px;
            padding: 48px 54px;
            background: #ffffff;
            border-radius: 34px;
            box-shadow: 0 24px 54px rgba(15, 23, 42, 0.08);
            text-align: left;
        }

        .app-showcase__info {
            display: flex;
            justify-content: flex-start;
        }

        .app-promo__eyebrow {
            margin: 0;
            color: #244ee8;
            font-size: 56px;
            font-weight: 800;
            line-height: 1.02;
        }

        .app-promo__title {
            margin: 6px 0 0;
            color: #27364d;
            font-size: 54px;
            font-weight: 800;
            line-height: 1.05;
        }

        .app-promo__text {
            margin: 30px 0 0;
            color: #334155;
            font-size: 22px;
            line-height: 1.6;
        }

        .app-promo__downloads {
            display: flex;
            align-items: flex-end;
            gap: 26px;
            margin-top: 34px;
        }

        .app-promo__stores {
          margin: auto 0;
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .app-showcase__visual {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .app-showcase__visual .gallery-stage {
            max-width: 620px;
            height: 560px;
        }

        .app-showcase__visual .gallery-item {
            width: 250px;
            height: 520px;
        }

        .app-showcase__visual .gallery-item.prev {
            transform: translateX(-135%) scale(0.82) rotateY(15deg);
        }

        .app-showcase__visual .gallery-item.next {
            transform: translateX(35%) scale(0.82) rotateY(-15deg);
        }

        .app-showcase__visual .gallery-item.active {
            transform: translateX(-50%) scale(1);
        }

        .footer-app {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 12px;
            margin-top: 18px;
        }

        .footer-links__title {
            margin: 0;
            color: #1f3552;
            font-size: 20px;
            font-weight: 700;
            line-height: 1.3;
            text-align: center;
        }

        .app-buttons {
            display: flex;
            gap: 12px;
            justify-content: center;
        }

        .app-store-btn {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            padding: 10px 16px;
            color: #ffffff;
            text-decoration: none;
            background-color: #000000;
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 8px;
            transition: opacity 0.2s ease, transform 0.2s ease;
        }

        .app-store-btn:hover {
            opacity: 0.9;
            transform: translateY(-2px);
        }

        .app-store-btn--large {
            min-width: 238px;
            padding: 14px 18px;
            border-radius: 12px;
            justify-content: flex-start;
        }

        .app-icon {
            width: 28px;
            height: 28px;
            flex-shrink: 0;
        }

        .app-text {
            display: flex;
            flex-direction: column;
            line-height: 1.2;
        }

        .app-small {
            font-size: 10px;
            opacity: 0.9;
        }

        .app-large {
            font-size: 16px;
            font-weight: 600;
        }

        .app-qr {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .app-qr__frame {
            position: relative;
            width: 184px;
            height: 184px;
            padding: 16px;
            background: #ffffff;
            border-radius: 18px;
            box-shadow: 0 16px 32px rgba(15, 23, 42, 0.12);
            overflow: hidden;
        }

        .app-qr__pattern {
            position: absolute;
            inset: 12px;
            border-radius: 10px;
            background-image: repeating-conic-gradient(#111827 0% 25%, #ffffff 0% 50%);
            background-size: 18px 18px;
            opacity: 0.92;
        }

        .app-qr__finder {
            position: absolute;
            width: 48px;
            height: 48px;
            border: 7px solid #111827;
            border-radius: 8px;
            background: #ffffff;
            z-index: 2;
        }

        .app-qr__finder::after {
            position: absolute;
            inset: 8px;
            content: "";
            border-radius: 3px;
            background: #111827;
        }

        .app-qr__finder--tl {
            top: 16px;
            left: 16px;
        }

        .app-qr__finder--tr {
            top: 16px;
            right: 16px;
        }

        .app-qr__finder--bl {
            bottom: 16px;
            left: 16px;
        }

        .app-qr__logo {
            position: absolute;
            inset: 0;
            z-index: 3;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .app-qr__logo-image {
            width: 52px;
            height: 52px;
            padding: 8px;
            background: #ffffff;
            border-radius: 50%;
            box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
            object-fit: contain;
        }

        @media (max-width: 1200px) {
            .app-showcase {
                grid-template-columns: 1fr;
                gap: 28px;
                padding: 36px 30px;
            }

            .app-promo__downloads {
                align-items: flex-start;
            }

            .app-showcase__visual .gallery-stage {
                max-width: 540px;
                height: 520px;
            }
        }

        @media (max-width: 768px) {
            .app-showcase {
                padding: 26px 18px;
                border-radius: 24px;
            }

            .app-promo__eyebrow {
                font-size: 40px;
            }

            .app-promo__title {
                font-size: 34px;
            }

            .app-promo__text {
                font-size: 18px;
            }

            .app-promo__downloads {
                flex-direction: column;
                gap: 18px;
            }

            .app-store-btn--large {
                min-width: 220px;
            }

            .app-showcase__visual .gallery-stage {
                max-width: 100%;
                height: 460px;
            }

            .app-showcase__visual .gallery-item {
                width: 220px;
                height: 450px;
            }

            .app-qr__frame {
                width: 156px;
                height: 156px;
            }
        }





.features-section {
  padding: 80px 0;
  background-color: #f8f9fa;
}

.features-container {
  margin: 0 auto;
  padding: 0 20px;
}

.features-header {
  text-align: center;
  margin-bottom: 60px;
}

.features-title {
  font-size: 36px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 16px;
}

.features-subtitle {
  font-size: 18px;
  color: #666666;
  max-width: 600px;
  margin: 0 auto;
}

/* 卡片网格 */
.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

/* 单个卡片 */
.feature-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 40px 24px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.feature-card h2 {
  font-size: 26px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 24px;
}

.feature-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

/* 图标 */
.feature-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 24px;
  background: linear-gradient(135deg, #244ee8 0%, #6b8cff 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

.feature-icon svg {
  width: 32px;
  height: 32px;
}

/* 卡片标题 */
.feature-card-title {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 12px;
}

/* 卡片描述 */
.feature-card-desc {
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
}

/* 响应式 */
.loan-estimator-section {
  display: flex;
  justify-content: center;
  padding: 36px 0 70px;
  background: #f8f9fa;
}

.loan-estimator-card {
  width: 100%;
  padding: 54px 48px 52px;
  background: #ffffff;
  border-radius: 48px;
  box-shadow: 0 20px 60px rgba(18, 38, 63, 0.08);
}

.loan-estimator-header {
  margin-bottom: 28px;
}

.loan-estimator-title {
  margin: 0;
  color: #1f3552;
  font-size: 58px;
  font-weight: 800;
  line-height: 1.08;
}

.loan-estimator-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 540px;
  gap: 22px;
  align-items: start;
}

.loan-estimator-controls {
  padding-right: 8px;
}

.loan-control + .loan-control {
  margin-top: 42px;
}

.loan-control__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 18px;
}

.loan-control__label {
  color: #091b33;
  font-size: 27px;
  font-weight: 700;
  line-height: 1.35;
}

.loan-control__value-box {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  min-width: 260px;
  padding: 16px 22px;
  border: 1px solid rgba(36, 78, 232, 0.18);
  border-radius: 6px;
  background: #f8fbff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.loan-control__value {
  color: #244ee8;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.loan-control__unit {
  color: #25364d;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
}

.loan-range {
  --range-progress: 100%;
  width: 100%;
  height: 12px;
  margin: 0;
  background: linear-gradient(
    to right,
    #244ee8 0%,
    #6b8cff var(--range-progress),
    rgba(36, 78, 232, 0.16) var(--range-progress),
    rgba(36, 78, 232, 0.16) 100%
  );
  border-radius: 999px;
  appearance: none;
  outline: none;
}

.loan-range::-webkit-slider-runnable-track {
  height: 12px;
  background: transparent;
  border-radius: 999px;
}

.loan-range::-webkit-slider-thumb {
  width: 26px;
  height: 26px;
  margin-top: -7px;
  background: #244ee8;
  border: 4px solid #244ee8;
  border-radius: 50%;
  box-shadow: 0 0 0 6px rgba(36, 78, 232, 0.14);
  appearance: none;
  cursor: pointer;
}

.loan-range::-moz-range-track {
  height: 12px;
  background: transparent;
  border: none;
  border-radius: 999px;
}

.loan-range::-moz-range-thumb {
  width: 26px;
  height: 26px;
  background: #244ee8;
  border: 4px solid #244ee8;
  border-radius: 50%;
  box-shadow: 0 0 0 6px rgba(36, 78, 232, 0.14);
  cursor: pointer;
}

.loan-control__limits {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  color: #26384f;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
}

.loan-estimator-summary {
  padding-top: 8px;
}

.loan-summary-box {
  padding: 38px 32px 34px;
  text-align: center;
  background: linear-gradient(180deg, #f8fbff 0%, #f3f7ff 100%);
  border-radius: 48px;
  border: 1px solid rgba(36, 78, 232, 0.08);
}

.loan-summary-box__label {
  margin: 0 0 18px;
  color: #24364d;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
}

.loan-summary-box__amount {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 10px;
  margin-bottom: 12px;
}

.loan-summary-box__amount-number {
  color: #244ee8;
  font-size: 68px;
  font-weight: 800;
  line-height: 0.95;
  letter-spacing: 0.01em;
}

.loan-summary-box__amount-unit {
  padding-bottom: 10px;
  color: #244ee8;
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  text-transform: uppercase;
}

.loan-summary-box__daily {
  margin: 0;
  color: #000000;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
}

.loan-summary-box__daily span {
  color: #244ee8;
}

.loan-summary-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: fit-content;
  min-width: 316px;
  margin: 34px auto 18px;
  padding: 18px 34px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  background: linear-gradient(135deg, #244ee8 0%, #6b8cff 100%);
  border-radius: 999px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.loan-summary-action::after {
  content: ">";
  font-size: 24px;
  line-height: 1;
}

.loan-summary-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 32px rgba(36, 78, 232, 0.24);
}

.loan-summary-note {
  margin: 0;
  color: #5e6775;
  font-size: 15px;
  line-height: 1.7;
}

.loan-steps-section {
  display: flex;
  justify-content: center;
  padding: 10px 0 84px;
  background: #f8f9fa;
}

.loan-steps-wrap {
  width: 100%;
}

.loan-steps-header {
  margin-bottom: 38px;
  text-align: center;
}

.loan-steps-title {
  margin: 0;
  color: #1f3552;
  font-size: 56px;
  font-weight: 800;
  line-height: 1.12;
}

.loan-steps-subtitle {
  margin: 14px 0 0;
  color: #274162;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
}

.loan-steps-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 26px;
  align-items: stretch;
}

.loan-step-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 310px;
  padding: 56px 34px 30px;
  background: #ffffff;
  border: 1px solid rgba(36, 78, 232, 0.06);
  border-radius: 42px;
  box-shadow: 0 22px 60px rgba(18, 38, 63, 0.08);
}

.loan-step-badge {
  position: absolute;
  top: -22px;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 62px;
  color: #ffffff;
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  background: linear-gradient(135deg, #244ee8 0%, #6b8cff 100%);
  border-radius: 50%;
  box-shadow: 0 14px 28px rgba(36, 78, 232, 0.28);
  transform: translateX(-50%);
}

.loan-step-copy {
  text-align: center;
}

.loan-step-title {
  margin: 0;
  color: #1f3552;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.35;
}

.loan-step-title-secondary {
  margin: 10px 0 18px;
  color: #244ee8;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.4;
}

.loan-step-text {
  margin: 10px 0 0;
  color: #5d6878;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.65;
}

.loan-step-visual {
  display: flex;
  align-items: flex-end;
  margin-top: auto;
  padding-top: 28px;
}

.loan-step-visual-frame {
  position: relative;
  width: 100%;
  height: 230px;
  overflow: hidden;
  background: linear-gradient(180deg, #f9fbff 0%, #eef4ff 100%);
  border-radius: 28px;
  border: 1px solid rgba(36, 78, 232, 0.08);
}

.loan-step-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(4px);
  opacity: 0.65;
}

.loan-step-glow--one {
  top: 26px;
  left: 22px;
  width: 34px;
  height: 34px;
  background: rgba(107, 140, 255, 0.14);
}

.loan-step-glow--two {
  right: 24px;
  bottom: 34px;
  width: 44px;
  height: 44px;
  background: rgba(36, 78, 232, 0.1);
}

.loan-step-floor {
  position: absolute;
  right: 32px;
  bottom: 26px;
  left: 32px;
  height: 24px;
  background: linear-gradient(180deg, rgba(36, 78, 232, 0.12), rgba(36, 78, 232, 0.02));
  border-radius: 50%;
}

.loan-step-chip,
.loan-step-magnifier,
.loan-step-hand,
.loan-step-cardboard,
.loan-step-avatar,
.loan-step-line,
.loan-step-success,
.loan-step-phone,
.loan-step-cash,
.loan-step-coin {
  position: absolute;
}

.loan-step-chip {
  left: 50%;
  bottom: 54px;
  width: 118px;
  height: 78px;
  background: linear-gradient(180deg, #ffffff 0%, #f0f5ff 100%);
  border: 1px solid rgba(36, 78, 232, 0.14);
  border-radius: 18px;
  box-shadow: 0 14px 26px rgba(36, 78, 232, 0.12);
  transform: translateX(-50%) rotate(-6deg);
}

.loan-step-chip::before {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 58px;
  height: 12px;
  content: "";
  background: linear-gradient(135deg, #244ee8 0%, #6b8cff 100%);
  border-radius: 999px;
}

.loan-step-chip::after {
  position: absolute;
  top: 40px;
  left: 20px;
  width: 78px;
  height: 10px;
  content: "";
  background: rgba(36, 78, 232, 0.16);
  border-radius: 999px;
}

.loan-step-magnifier {
  left: 50%;
  bottom: 62px;
  width: 38px;
  height: 38px;
  border: 5px solid #244ee8;
  border-radius: 50%;
  transform: translateX(-8px);
}

.loan-step-magnifier::after {
  position: absolute;
  right: -16px;
  bottom: -14px;
  width: 18px;
  height: 6px;
  content: "";
  background: #244ee8;
  border-radius: 999px;
  transform: rotate(42deg);
}

.loan-step-hand {
  right: 94px;
  bottom: 12px;
  width: 30px;
  height: 74px;
  background: linear-gradient(180deg, #ffdcc2 0%, #f5bf93 100%);
  border-radius: 18px 18px 10px 10px;
  transform: rotate(-18deg);
}

.loan-step-cardboard {
  top: 58px;
  left: 50%;
  width: 126px;
  height: 84px;
  background: linear-gradient(180deg, #ffffff 0%, #edf4ff 100%);
  border: 1px solid rgba(36, 78, 232, 0.15);
  border-radius: 16px;
  box-shadow: 0 14px 26px rgba(36, 78, 232, 0.12);
  transform: translateX(-50%) rotate(5deg);
}

.loan-step-avatar {
  top: 78px;
  left: calc(50% - 40px);
  width: 28px;
  height: 28px;
  background: radial-gradient(circle at 50% 38%, #ffcad4 0 36%, transparent 37%),
    linear-gradient(180deg, #244ee8 0%, #6b8cff 100%);
  border-radius: 50%;
}

.loan-step-avatar::after {
  position: absolute;
  bottom: -18px;
  left: 50%;
  width: 42px;
  height: 22px;
  content: "";
  background: rgba(36, 78, 232, 0.9);
  border-radius: 999px 999px 10px 10px;
  transform: translateX(-50%);
}

.loan-step-line {
  left: calc(50% - 2px);
  height: 10px;
  background: rgba(36, 78, 232, 0.18);
  border-radius: 999px;
}

.loan-step-line--one {
  top: 82px;
  width: 44px;
}

.loan-step-line--two {
  top: 106px;
  width: 60px;
}

.loan-step-success {
  right: calc(50% - 70px);
  bottom: 66px;
  width: 42px;
  height: 42px;
  background: linear-gradient(135deg, #32d7a1 0%, #6ce8bc 100%);
  border-radius: 50%;
  box-shadow: 0 10px 24px rgba(50, 215, 161, 0.26);
}

.loan-step-success::after {
  position: absolute;
  top: 11px;
  left: 12px;
  width: 15px;
  height: 8px;
  content: "";
  border-bottom: 4px solid #ffffff;
  border-left: 4px solid #ffffff;
  transform: rotate(-45deg);
}

.loan-step-phone {
  bottom: 40px;
  left: 50%;
  width: 92px;
  height: 132px;
  background: linear-gradient(180deg, #244ee8 0%, #5d87ff 100%);
  border-radius: 22px;
  box-shadow: 0 16px 32px rgba(36, 78, 232, 0.22);
  transform: translateX(-50%) rotate(-2deg);
}

.loan-step-phone::before {
  position: absolute;
  top: 12px;
  left: 50%;
  width: 40px;
  height: 6px;
  content: "";
  background: rgba(255, 255, 255, 0.82);
  border-radius: 999px;
  transform: translateX(-50%);
}

.loan-step-phone::after {
  position: absolute;
  top: 34px;
  left: 14px;
  right: 14px;
  bottom: 14px;
  content: "";
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94) 0%, rgba(228, 236, 255, 0.92) 100%);
  border-radius: 14px;
}

.loan-step-cash {
  background: linear-gradient(180deg, #ffffff 0%, #edf3ff 100%);
  border: 1px solid rgba(36, 78, 232, 0.15);
  border-radius: 12px;
  box-shadow: 0 12px 22px rgba(36, 78, 232, 0.08);
}

.loan-step-cash--one {
  right: 88px;
  bottom: 62px;
  width: 56px;
  height: 34px;
  transform: rotate(18deg);
}

.loan-step-cash--two {
  left: 96px;
  bottom: 48px;
  width: 62px;
  height: 38px;
  transform: rotate(-14deg);
}

.loan-step-coin {
  right: 112px;
  bottom: 34px;
  width: 26px;
  height: 26px;
  background: radial-gradient(circle at 30% 30%, #ffe4a3 0%, #f5b93f 72%, #d99819 100%);
  border-radius: 50%;
  box-shadow: 0 10px 18px rgba(245, 185, 63, 0.25);
}

@media (max-width: 1280px) {
  .loan-steps-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .loan-estimator-body {
    grid-template-columns: 1fr;
  }

  .loan-estimator-controls {
    padding-right: 0;
  }
}

@media (max-width: 900px) {
  .loan-steps-title {
    font-size: 38px;
  }

  .loan-steps-subtitle {
    font-size: 22px;
  }

  .loan-steps-grid {
    grid-template-columns: 1fr;
  }

  .loan-step-card {
    min-height: 0;
    padding: 54px 24px 24px;
    border-radius: 30px;
  }

  .loan-estimator-card {
    padding: 36px 24px 40px;
    border-radius: 28px;
  }

  .loan-estimator-title {
    font-size: 40px;
  }

  .loan-control__top {
    flex-direction: column;
    align-items: flex-start;
  }

  .loan-control__value-box {
    min-width: 0;
    width: 100%;
  }

  .loan-summary-box__amount-number {
    font-size: 50px;
  }

  .loan-summary-action {
    width: 100%;
    min-width: 0;
  }
}

@media (max-width: 1024px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .loan-steps-section {
    padding-bottom: 56px;
  }

  .loan-step-badge {
    width: 54px;
    height: 54px;
    font-size: 24px;
  }

  .loan-step-title {
    font-size: 22px;
  }

  .loan-step-text {
    font-size: 15px;
  }

  .loan-step-visual-frame {
    height: 200px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .features-title {
    font-size: 28px;
  }
}

/* Container Setup */
        .expand-gallery-shell {
          width: 100%;
          margin: 0 auto;
          padding: 0 20px 36px;
          box-sizing: border-box;
        }

        .service-showcase {
          position: relative;
          display: grid;
          grid-template-columns: 56px minmax(0, 1fr) 56px;
          gap: 28px;
          align-items: center;
          width: 100%;
        }

        .service-showcase__card {
          display: grid;
          grid-template-columns: minmax(0, 1.08fr) minmax(320px, 1fr);
          min-height: 360px;
          background: #ffffff;
          border-radius: 28px;
          box-shadow: 0 16px 38px rgba(15, 23, 42, 0.08);
          overflow: hidden;
        }

        .service-showcase__media {
          min-height: 360px;
          background: #f3f4f6;
        }

        .service-showcase__image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .service-slide-fade-enter-active,
        .service-slide-fade-leave-active {
          transition: opacity 0.28s ease;
        }

        .service-slide-fade-enter,
        .service-slide-fade-leave-to {
          opacity: 0;
        }

        .service-copy-fade-enter-active,
        .service-copy-fade-leave-active {
          transition: opacity 0.28s ease, transform 0.28s ease;
        }

        .service-copy-fade-enter,
        .service-copy-fade-leave-to {
          opacity: 0;
          transform: translateY(10px);
        }

        .service-showcase__content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 44px 42px 34px;
        }

        .service-showcase__copy {
          max-width: 550px;
        }

        .service-showcase__title {
          width: 100%;
          margin: 0 0 20px 0;
          color: #111827;
          font-size: 32px;
          font-weight: 700;
          line-height: 1.2;
        }

        .service-showcase__link {
          margin-top: 22px;
          padding: 0;
          border: none;
          background: transparent;
          color: #244ee8;
          font-size: 24px;
          font-weight: 700;
          line-height: 1.2;
          cursor: pointer;
          text-align: left;
        }

        .service-showcase__dots {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .service-showcase__dot {
          width: 10px;
          height: 10px;
          padding: 0;
          border: none;
          border-radius: 50%;
          background: #d1d5db;
          cursor: pointer;
          transition: transform 0.2s ease, background-color 0.2s ease;
        }

        .service-showcase__dot.is-active {
          background: #ef233c;
          transform: scale(1.1);
        }

        .service-showcase__arrow {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 56px;
          height: 56px;
          padding: 0;
          border: 1px solid rgba(15, 23, 42, 0.08);
          border-radius: 50%;
          background: #ffffff;
          color: #374151;
          font-size: 38px;
          line-height: 1;
          box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
          cursor: pointer;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .service-showcase__arrow:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 22px rgba(15, 23, 42, 0.14);
        }

        .service-showcase__arrow span {
          display: block;
          transform: translateY(-2px);
        }

        .expand-gallery {
          display: flex;
          width: 100%;
          height: 600px;
          gap: 0; /* No gap for seamless look */
        }

        /* Panel Base Styles */
        .expand-panel {
          position: relative;
          flex: 1; /* Default state: all equal */
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          border-right: 1px solid rgba(255,255,255,0.1);
          cursor: pointer;
          transition: flex 0.7s cubic-bezier(0.25, 1, 0.5, 1); /* Smooth ease-out */
          overflow: hidden;
        }
        
        .expand-panel:last-child {
           border-right: none;
        }

        /* Desktop Hover Interaction */
        @media (min-width: 769px) {
            .expand-panel:hover {
              flex: 6; /* Expand significantly */
            }
            .expand-panel:hover .panel-overlay {
               background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%);
            }
            .expand-panel:hover .panel-content {
               opacity: 1;
            }
            .expand-panel:hover .panel-desc {
               opacity: 1;
               max-height: 100px; 
               transform: translateY(0);
               margin-bottom: 1rem;
            }
            .expand-panel:hover .panel-btn {
               opacity: 1;
               transform: translateY(0);
            }
            .expand-panel:hover .panel-num {
               opacity: 0.8;
               color: #3b82f6; 
               transform: translateY(-10px) scale(0.8);
               transform-origin: left bottom;
            }
        }

        /* Dark Overlay */
        .panel-overlay {
           position: absolute;
           inset: 0;
           background: linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.8) 100%);
           transition: background 0.3s ease;
           z-index: 1;
        }

        /* Text Content Handling */
        .panel-content {
           position: relative;
           z-index: 2;
           color: white;
           opacity: 0.8;
           transition: opacity 0.3s ease, transform 0.5s ease;
        }

        .text-wrapper {
           max-width: 400px;
           min-width: 200px; 
        }

        .panel-num {
           font-size: 4rem;
           font-weight: 900;
           line-height: 1;
           opacity: 0.2;
           margin-bottom: -10px;
           transform: translateY(0);
           transition: all 0.5s ease;
        }
        
        .panel-title {
           font-weight: 800;
           font-size: 1.5rem;
           text-transform: uppercase;
           letter-spacing: 2px;
           margin-bottom: 0.5rem;
           /* white-space: nowrap; */
           color: white;

        }

        .panel-desc {
           font-size: 1.1rem;
           font-weight: 300;
           opacity: 0; /* Hidden by default */
           max-height: 0;
           overflow: hidden;
           transform: translateY(20px);
           transition: all 0.5s ease;
        }
        
        .panel-btn {
           opacity: 0;
           transform: translateY(20px);
           transition: all 0.6s ease 0.1s;
        }

        /* Mobile Responsiveness & Interaction */
        @media (max-width: 768px) {
           .expand-gallery-shell {
              padding: 0 16px 28px;
           }

           .service-showcase {
              grid-template-columns: 1fr;
              gap: 16px;
           }

           .service-showcase__arrow {
              display: none;
           }

           .service-showcase__card {
              grid-template-columns: 1fr;
              min-height: 0;
           }

           .service-showcase__media {
              min-height: 220px;
           }

           .service-showcase__content {
              padding: 26px 22px 24px;
              gap: 24px;
           }

           .service-showcase__title {
              font-size: 28px;
           }

           .service-showcase__link {
              font-size: 18px;
           }

           .expand-gallery {
              flex-direction: column;
              height: auto;
           }
           .expand-panel {
              height: 100px; /* Collapsed Height */
              flex: none; 
              width: 100%;
              transition: height 0.5s cubic-bezier(0.25, 1, 0.5, 1);
              border-bottom: 1px solid rgba(255,255,255,0.2);
           }
           
           /* --- Mobile Optimization: Prevent Text Cutoff --- */
           
           /* In collapsed state: Shrink font, reduce padding, allow wrap */
           .panel-title {
               font-size: 1.1rem; 
               white-space: normal; /* Allow wrap on mobile */
               margin-bottom: 0.25rem;
               line-height: 1.2;
           }
           
           .panel-num {
               font-size: 1.5rem; /* Shrink number significantly */
               margin-bottom: 0;
           }
           
           .panel-content {
               padding: 1rem !important; /* Tighter padding for mobile strip */
               align-items: center !important; /* Center vertically in the strip */
               justify-content: flex-start !important; /* Align left */
           }
           
           .text-wrapper {
               width: 100%;
           }

           /* --- Active State (Expanded) --- */
           
           /* Mobile Active State (Clicked) */
           .expand-panel.active {
              height: 450px; /* Expanded Height */
           }
           
           /* Restore Sizes when Expanded */
           .expand-panel.active .panel-title {
               font-size: 1.75rem;
               margin-bottom: 0.5rem;
           }
           
           .expand-panel.active .panel-num {
               font-size: 3rem;
               margin-bottom: -5px;
           }
           
           .expand-panel.active .panel-content {
               padding: 2rem !important; /* More breathing room when active */
               align-items: flex-end !important; /* Back to bottom alignment */
           }

           /* Active State Effects */
           .expand-panel.active .panel-overlay {
              background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%);
           }
           
           .panel-content {
               opacity: 0.9;
           }
           .expand-panel.active .panel-content {
               opacity: 1;
           }

           .expand-panel.active .panel-desc {
              opacity: 1;
              max-height: 200px;
              transform: translateY(0);
              margin-bottom: 1rem;
           }
           .expand-panel.active .panel-btn {
              opacity: 1;
              transform: translateY(0);
           }
           .expand-panel.active .panel-num {
              opacity: 0.8;
              color: #3b82f6; 
              transform: translateY(-10px) scale(0.8);
              transform-origin: left bottom;
           }
        }

/* 下载按钮固定在 Banner 上 */
.download-btn-fixed {
  width: 300px;
  height: 80px;
  position: absolute;
  bottom: 160px;
  left: 20%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: linear-gradient(135deg, #244ee8 0%, #6b8cff 100%);
  color: #ffffff;
  padding: 0 40px;
  border-radius: 50px;
  text-decoration: none;
  font-size: 24px;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(36, 78, 232, 0.4);
  transition: all 0.3s ease;
  z-index: 10;
}

.download-btn-fixed:hover {
  transform: translateX(-50%) translateY(-3px);
  box-shadow: 0 8px 25px rgba(36, 78, 232, 0.5);
}

.download-btn-icon {
  width: 32px;
  height: 32px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .download-btn-fixed {
    width: 200px;
    height: 56px;
    bottom: 40px;
    padding: 0 24px;
    font-size: 16px;
    gap: 10px;
  }
  
  .download-btn-icon {
    width: 22px;
    height: 22px;
  }
}

</style>







 <!-- <script>
        ()();
      </script> -->
